module.exports = __webpack_public_path__ + "img/tickets-r3-processing-admin-mgt.0e0865c5.png";